import { PropsWithChildren, useEffect } from 'react';
import { THEME_STORAGE_KEY, ThemeEnum } from '@/Domain/enum/Theme.enum';
import { resolveTheme, useThemeStore } from '@/Domain/store/theme.store';

function applyTheme(theme: ThemeEnum): void {
  const resolvedTheme = resolveTheme(theme);
  const root = window.document.documentElement;

  root.classList.remove(ThemeEnum.Light, ThemeEnum.Dark);
  root.classList.add(resolvedTheme);
  root.dataset.theme = theme;
  root.style.colorScheme = resolvedTheme;
}

export function ThemeProvider({ children }: PropsWithChildren) {
  const theme = useThemeStore((state) => state.theme);
  const syncTheme = useThemeStore((state) => state.syncTheme);

  useEffect(() => {
    applyTheme(theme);

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleSystemThemeChange = () => {
      if (useThemeStore.getState().theme === ThemeEnum.System) {
        applyTheme(ThemeEnum.System);
      }
    };

    const handleStorageChange = (event: StorageEvent) => {
      if (event.key !== THEME_STORAGE_KEY) {
        return;
      }

      syncTheme();
    };

    mediaQuery.addEventListener('change', handleSystemThemeChange);
    window.addEventListener('storage', handleStorageChange);

    return () => {
      mediaQuery.removeEventListener('change', handleSystemThemeChange);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [theme, syncTheme]);

  return <>{children}</>;
}
